import { render, staticRenderFns } from "./MerchantAgents.vue?vue&type=template&id=6d01a2bf"
import script from "./MerchantAgents.vue?vue&type=script&lang=js"
export * from "./MerchantAgents.vue?vue&type=script&lang=js"
import style0 from "./MerchantAgents.vue?vue&type=style&index=0&id=6d01a2bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports